
export function setupCarouselArrowFocus(delay = 300) {
    const timer = setTimeout(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                setTimeout(() => {
                    
                    const isSFv2Container = !!document.querySelector('.app-body-v2');
                    if (!isSFv2Container) return;

                    
                    let container = document.activeElement;
                    while (container && !container.classList?.contains('react-multi-carousel-list')) {
                        container = container.parentElement;
                    }
                    
                    if (!container) {
                        container = e.target.closest('.react-multi-carousel-list');
                    }
                    if (!container) return;

                    const arrowSelector = e.key === 'ArrowLeft'
                        ? '.react-multiple-carousel__arrow--left'
                        : '.react-multiple-carousel__arrow--right';
                    const arrow = container.querySelector(arrowSelector);
                    if (arrow) arrow.focus();
                }, 0);
            }
        };

        
        const containers = document.querySelectorAll('.react-multi-carousel-list');
        containers.forEach((container) => {
            container.addEventListener('keydown', handleKeyDown);
        });

        
        return () => {
            containers.forEach((container) => {
                container.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, delay);

    
    return () => clearTimeout(timer);
}



export function setupCarouselTabFocus(arrowKeyNavRef) {
    const containers = document.querySelectorAll('.react-multi-carousel-list');

    function getFocusableElements(container) {
        const visibleSlides = container.querySelectorAll(
            '.react-multi-carousel-item--active:not(.react-multi-carousel-item--cloned)'
        );
        const focusableSelectors = '[tabindex], a, button, input, [role="button"]';
        const focusables = [];
        visibleSlides.forEach((slide) => {
            slide.querySelectorAll(focusableSelectors).forEach(el => focusables.push(el));
        });
        return focusables;
    }

    function handleForwardTab(e, container, last) {
        if (!e.shiftKey && document.activeElement === last) {
            const rightArrow = container.querySelector('.react-multiple-carousel__arrow--right');
            
            if (rightArrow && !rightArrow.disabled && !rightArrow.getAttribute('aria-disabled')) {
                e.preventDefault();
                rightArrow.click();
            }
            
        }
    }

    function handleReverseTab(e, container, first) {
        if (e.shiftKey && document.activeElement === first) {
            const leftArrow = container.querySelector('.react-multiple-carousel__arrow--left');
            if (leftArrow && !leftArrow.disabled && !leftArrow.getAttribute('aria-disabled')) {
                e.preventDefault();
                leftArrow.click();
            }
        }
    }

    function handleTabNavigation(e, container) {
        const focusables = getFocusableElements(container);
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        handleForwardTab(e, container, last);
        handleReverseTab(e, container, first);
    }

    function handleKeyDown(e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            arrowKeyNavRef.current = true;
        }

        if (e.key === 'Tab') {
            const container = e.currentTarget;
            handleTabNavigation(e, container);
        }
    }

    containers.forEach((container) => {
        container.addEventListener('keydown', handleKeyDown);
    });

    return () => {
        containers.forEach((container) => {
            container.removeEventListener('keydown', handleKeyDown);
        });
    };
}
